/**
 * A visitor's own goal pick (the hub's goal picker, signed out), kept in
 * the browser until an account takes it over (lib/use-personal copies it
 * onto a new account that has none). Its own module so the welcome card,
 * which every page carries, can read it without the hub's data layer.
 */
export const VISITOR_GOAL_KEY = "menzil_goal";

/** The raw stored pick; callers check it against their own goal list. */
export function readVisitorGoal(): string | null {
  try {
    return localStorage.getItem(VISITOR_GOAL_KEY);
  } catch {
    return null;
  }
}
